import React, { useEffect, useRef, useState } from 'react';

const STEPS = ['Rates', 'Print Size', 'Digital', 'Duration', 'Contact', 'Review & Pay'];

// Connector path: a plain straight line — the lightning personality lives in
// the animations (comet spark + strike flash), not the line shape.
// pathLength=100 normalizes stroke-dash math regardless of rendered width.
const BOLT_POINTS = '0,10 100,10';

export default function ProgressBar({ currentStep }) {
  const prevRef = useRef(currentStep);
  // {from, to} while the advance animation is in flight, null otherwise.
  const [anim, setAnim] = useState(null);

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = currentStep;
    if (currentStep > prev) {
      setAnim({ from: prev, to: currentStep });
      const t = setTimeout(() => setAnim(null), 800);
      return () => clearTimeout(t);
    }
  }, [currentStep]);

  return (
    <div className="progress-bar">
      {STEPS.map((label, i) => {
        const n      = i + 1;
        const done   = n < currentStep;
        const active = n === currentStep;
        // Spark runs along every connector crossed in this advance (usually one);
        // the arrival bubble takes the strike flash.
        const spark  = !!anim && n >= anim.from && n < anim.to;
        const struck = !!anim && n === anim.to;
        return (
          <div
            key={n}
            className={`progress-step${done ? ' done' : ''}${active ? ' active' : ''}`}
          >
            {n < STEPS.length && (
              <svg
                className={`bolt-connector${spark ? ' spark' : ''}`}
                viewBox="0 0 100 20"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <polyline className="bolt-base"  points={BOLT_POINTS} pathLength="100" />
                <polyline className="bolt-fill"  points={BOLT_POINTS} pathLength="100" />
                <polyline className="bolt-spark" points={BOLT_POINTS} pathLength="100" />
              </svg>
            )}
            <div className={`step-bubble${struck ? ' struck' : ''}`}>{done ? '✓' : n}</div>
            <span className="step-label">{label}</span>
          </div>
        );
      })}
    </div>
  );
}
